import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import Navbar from './Navbar';
import './Schedule.css';

function Schedule() {
  return (
    <div className="schedule-section">
      <Helmet>
        <title>Portugal Pavilion Schedule | Carassauga 2025 Events & Activities</title>
        <meta name="description" content="View the complete schedule for Portugal Pavilion at Carassauga 2025. See all events, performances, and activities happening Friday, Saturday, and Sunday." />
        <meta name="keywords" content="Portugal Pavilion schedule, Carassauga 2025 events, Portuguese performances, cultural activities, Mississauga festival schedule" />
        <link rel="canonical" href="https://carassauga2025.web.app/schedule" />
      </Helmet>
      <Navbar />

      {/* FRIDAY */}
      <motion.div
        className="schedule-day-title"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <img
          className="schedule-day-img"
          src="/images/schedule/friday-title.svg"
          alt="FRIDAY"
        />
      </motion.div>

      <div className="schedule-table">
        <div className="schedule-row">
          <span className="schedule-time">7:00 PM</span>
          <span className="schedule-act">DJ Good Vibes</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">8:00 PM</span>
          <span className="schedule-act">PCCM - Rancho Juvenil</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">9:00 PM</span>
          <span className="schedule-act"> Nazare</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">9:30 PM</span>
          <span className="schedule-act">Clube de Vaughn (Os Antigos)</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">10:00 PM</span>
          <span className="schedule-act">Cristiana Sá</span>
        </div>
      </div>

      {/* SATURDAY */}
      <motion.div
        className="schedule-day-title"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <img
          className="schedule-day-img"
          src="/images/schedule/saturday-title.svg"
          alt="SATURDAY"
        />
      </motion.div>

      <div className="schedule-table">
        <div className="schedule-row">
          <span className="schedule-time">12:00 PM</span>
          <span className="schedule-act">Opening - PCCM School</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">1:00 PM</span>
          <span className="schedule-act">PCCM Rancho Juvenil</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">1:30 PM</span>
          <span className="schedule-act">DJ Good Vibes</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">2:00 PM</span>
          <span className="schedule-act">Live Cooking Show</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">2:30 PM</span>
          <span className="schedule-act">Oshawa do Northen of Portugal</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">3:00 PM</span>
          <span className="schedule-act">Cristiana Sá</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">4:00 PM</span>
          <span className="schedule-act">Provincia Ilhas Hamilton</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">5:00 PM</span>
          <span className="schedule-act">DJ Good Vibes</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">6:00 PM</span>
          <span className="schedule-act">R.F. As Tricanas </span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">7:00 PM</span>
          <span className="schedule-act">Cristiana Sa</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">8:00 PM</span>
          <span className="schedule-act">PCCM folklore</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">9:00 PM</span>
          <span className="schedule-act">R.F.Arsenal do Minho</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">10:00 PM</span>
          <span className="schedule-act">Cristiana Sá</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">11:00 PM</span>
          <span className="schedule-act">DJ Good Vibes</span>
        </div>
      </div>

      {/* SUNDAY */}
      <motion.div
        className="schedule-day-title"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <img
          className="schedule-day-img"
          src="/images/schedule/sunday-title.svg"
          alt="SUNDAY"
        />
      </motion.div>

      <div className="schedule-table">
        <div className="schedule-row">
          <span className="schedule-time">12:00 PM</span>
          <span className="schedule-act">DJ Good Vibes</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">1:00 PM</span>
          <span className="schedule-act">PCCM Rancho Juvenil</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">1:30 PM</span>
          <span className="schedule-act">R.F. Camponese de Toronto</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">2:00 PM</span>
          <span className="schedule-act">Cristiana Sá</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">3:00 PM</span>
          <span className="schedule-act">CR.F.ACMT-Bombos</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">4:00 PM</span>
          <span className="schedule-act">Rancho PCCM</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">5:00 PM</span>
          <span className="schedule-act">Cristiana Sá</span>
        </div>
        <div className="schedule-row">
          <span className="schedule-time">6:30 PM</span>
          <span className="schedule-act">Closing Ceremonies</span>
        </div>
      </div>
    </div>
  );
}

export default Schedule;
